import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, PhoneCall } from "lucide-react";
import "../../Style/floatingCall.css";

// Replace with your actual company phone number
const PHONE_NUMBER = "+1 786 776 2152";
const TEL_LINK = "tel:+17867762152";

export default function FloatingCall() {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      className="floating-call"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Expanding Tooltip / Phone Number Label on Desktop */}
      <AnimatePresence>
        {isHovered && (
          <motion.a
            href={TEL_LINK}
            className="floating-call__tooltip notranslate"
            initial={{ opacity: 0, x: -10, scale: 0.95 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: -10, scale: 0.95 }}
            transition={{ duration: 0.18, ease: "easeOut" }}
          >
            <span className="floating-call__tooltip-sub">Speak to an Expert</span>
            <strong className="floating-call__tooltip-num">{PHONE_NUMBER}</strong>
          </motion.a>
        )}
      </AnimatePresence>

      {/* Main Floating Call Button */}
      <motion.a
        href={TEL_LINK}
        className="floating-call__btn"
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.94 }}
        aria-label="Call Us"
      >
        {/* Soft Animated Radar Wave */}
        <span className="floating-call__ping" />
        
        {/* Icon */}
        <span className="floating-call__icon-wrapper">
          <Phone className="floating-call__icon" size={20} />
          <PhoneCall className="floating-call__icon--hover" size={20} />
        </span>
      </motion.a>
    </div>
  );
}